export const filterUserCustomers = (dataFilter, customers) => {

    return customers?.filter((customer) => {

        return customer?.status === dataFilter

    });
};